export { default } from "@/features/profile/screens/user-profile";
